"use strict";
import $ from 'jquery';

var Core = $.core.reporting.html = {
    initialize: function () {
        this.build();
        this.events();
    },
    build: function () {
        Core.initDatatables();
        Core.initCharts();
    },
    events: function () {

    },
    initDatatables: function () {
        $('div.report-table-container table').each(function() {
            var options = $.core.datatable.staticOptions('item');
            $.core.datatable.build($(this), options);
        });
    },
    initCharts: function () {
        var chartWidth = $('#report-content').width();
        $('div.chart-container div.json-chart-data').each(function() {
            //JSON data is contained within the html
            //NOTE: data is passed this way so that pdf generator can grab it directly from the html since it only has access to html
            var data = $.parseJSON($(this).html());
            var $chart = $(this).parent();

            //Remove to avoid bloating html with json data
            $(this).remove();

            if (data.chartType == $.globals.chart.type.pie) {
                $.core.chart.buildPieChart($chart, data, {width: chartWidth, height: 200, isMultiAxis: true});
            }
            else if (data.chartType == $.globals.chart.type.line) {
                $.core.chart.buildSeriesChart($chart, data, {width: chartWidth, isMultiAxis: true});
            }
            else {
                alert('Invalid chart type');
            }
        });
    }
};